module.exports = __webpack_public_path__ + "img/CriticalHeightPlot-min.75cecefe.png";